import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=ba63d2e2&scoped=true&lang=html&"
import script from "./HeaderSection.vue?vue&type=script&lang=js&"
export * from "./HeaderSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba63d2e2",
  null
  
)

export default component.exports